/**
 * Component registry — Map-based singleton for per-client component overrides.
 * Registrations are static per page load; no reactivity needed.
 */

const registry = new Map();

export const componentRegistry = {
  register(name, component) {
    registry.set(name, component);
  },

  get(name) {
    return registry.get(name) ?? null;
  },

  /**
   * Called during bootstrap in main.js with the resolved config.
   * Register client-specific overrides here based on features.
   */
  setup(config) {
    // Placeholder: add per-client registrations as injection points are defined.
    // Example:
    // if (config.features.lottieAnimations) {
    //   componentRegistry.register('category-buttons', LottieCategoryButtons)
    // }
  },
};
